import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import React from 'react'

interface Props {
    disabled: boolean
    onClickHandler: React.MouseEventHandler<HTMLButtonElement> | undefined
}

const NextButton: React.FC<Props> = ({ disabled, onClickHandler }: Props) => {
    return (
        <Container
            style={{
                marginBottom: '2rem',
                display: 'inline block',
                alignContent: 'left',
                padding: '0',
                maxWidth: '100%',
            }}
        >
            <Button
                data-testid="next-btn"
                disabled={disabled}
                onClick={onClickHandler}
            >
                Next
            </Button>
        </Container>
    )
}

export default NextButton
